export interface PriceColor {
  color: string;
}

export const PRICE_COLORS: PriceColor[] = [
  { color: "#1A9436" },
  { color: "#48A4FF" },
  { color: "#8C5F00" },
  { color: "#6093B8" },
  { color: "#BCE3FF" },
  { color: "#00C6A7" },
  { color: "#003357" },
  { color: "#006B61" },
  { color: "#FFE2A6" }
];